import React from "react";

import * as S from "./styles";

export const Slide17: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Title>groove glorioso</S.Title>
        <S.Text>
          Sandy & Júnior e Amy Winehouse se misturam à Lady Gaga e Nicki Minaj
          no caldeirão de referências de Gloria Groove.
        </S.Text>
      </S.Wrapper>
    </S.Container>
  );
};
